// extracted by mini-css-extract-plugin
export default {"loader_container":"MediumLoader_loader_container__I-Cr-","loader":"MediumLoader_loader__0Rz-u","spinner-c7wet2":"MediumLoader_spinner-c7wet2__Qfo6H"};